/** @format */

import React, { useState, useEffect } from 'react'
import * as Styles from './style'
import { Formik } from 'formik'
import * as Yup from 'yup'
import axios from 'axios'
import Cookies from 'universal-cookie'
import close from '../../../assets/images/close.png'
import { toast } from 'react-toastify'
import { SelectGroup } from '../../../shared/SelectGroup/SelectGroup'
import { InputGroup } from '../../../shared/InputGroup/InputGroup'
import { Button, message } from 'antd'
const readCookie = require('../../../../cookie.js').readCookie

const cookies = new Cookies()

// ✅ Validation Schema
const clfSchema = Yup.object().shape({
  name: Yup.string().required('VO Name is required'),
})

// ✅ Component
const CreateVOForm = ({
  showClfModal,
  setShowClfModal,
  onSuccess,
  clfName,
  clfId,
}) => {
  console.log('CreateVOForm props => ', { showClfModal, clfName, clfId })
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [states, setStates] = useState([])
  const [districts, setDistricts] = useState([])
  const [blocks, setBlocks] = useState([])
  const [selectedState, setSelectedState] = useState('')
  const [selectedDistrict, setSelectedDistrict] = useState('')

  const token = cookies.get('access_token')

  const handleClose = () => setShowClfModal(false)

  const handleSubmit = async values => {
    setIsSubmitting(true)
    console.log('Form Values:', values)
    try {
      const payload = {
        name: values.name.trim(),
        clfId: clfId,
      }
      console.log('Payload:', payload)

      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/v1/humblebee/clf/vo/create`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            source: 'humblebee_admin',
          },
        }
      )

      toast.success('VO created successfully')
      onSuccess()
      handleClose()
    } catch (err) {
      toast.error('Failed to create: ' + err?.response?.data?.message || '')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Styles.ModalWrapper style={{ display: showClfModal ? 'flex' : 'none' }}>
      <Styles.ModalContent>
        <Formik
          initialValues={{
            name: '',
            clfId: clfId,
          }}
          validationSchema={clfSchema}
          onSubmit={handleSubmit}
        >
          {formik => (
            <Styles.FormWithCloseButton onSubmit={formik.handleSubmit}>
              <Styles.CloseButtonDiv>
                <h3>Create New VO</h3>
                <Styles.FormCloseButton onClick={handleClose}>
                  <img src={close} alt="Close" />
                </Styles.FormCloseButton>
              </Styles.CloseButtonDiv>

              <Styles.MainSupplierFormDiv>
                <InputGroup
                  PlaceholderText={clfName}
                  LabelText="CLF Name"
                  name="clfName"
                  type="text"
                  isDisabled={true}
                  star="*"
                  value={clfName}
                />
                <InputGroup
                  PlaceholderText={clfId}
                  LabelText="CLF Id"
                  name="clfId"
                  type="text"
                  isDisabled={true}
                  star="*"
                  value={clfId}
                />
                <InputGroup
                  PlaceholderText="Enter VO Name"
                  LabelText="VO Name"
                  name="name"
                  type="text"
                  star="*"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                />
              </Styles.MainSupplierFormDiv>

              <Button
                type="primary"
                htmlType="submit"
                loading={isSubmitting}
                className="mt-4"
              >
                {isSubmitting ? 'Creating...' : 'Create VO'}
              </Button>
            </Styles.FormWithCloseButton>
          )}
        </Formik>
      </Styles.ModalContent>
    </Styles.ModalWrapper>
  )
}

export default CreateVOForm
